"use strict";

module.exports = function (item) {
  return item === null || item === undefined;
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/value/isNothing.js
// module id = 2210
// module chunks = 37